module.exports = __webpack_public_path__ + "static/img/TOP@2x.323f9e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/TOP@2x.png
// module id = n1FK
// module chunks = 0